import useAccountSettings from '@/composables/logged-in-user-account/account-settings';
import useUsers from '@/composables/user/users';
import { computed } from 'vue';
import { productPlan } from 'shared/constants.json';

export default function useUserLimit() {
  const { accountSettings } = useAccountSettings();
  const { users } = useUsers();

  const nonDemoUserCount = computed(() => users.value.filter((u) => !u.isDemo).length);

  const userLimitValue = computed(() => accountSettings.value?.userLimit);

  const userLimitReached = computed(
    () => accountSettings.value.planId === productPlan.trial
      && nonDemoUserCount.value >= userLimitValue.value,
  );

  return {
    nonDemoUserCount,
    userLimitValue,
    userLimitReached,
  };
}
